import { ADDEDFILTER } from "./actionIdentifier";

const initialState = {
    status: "",
};

const filterReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADDEDFILTER:
            return {
                ...state,
                status: action.payload,
            };

        default:
            return state;
    }
};

export default filterReducer;
